export const devRoutes = [
    {
        name: 'admin-data-connections',
        path: '/admin-data-connections',
        component: (resolve) =>
            require(['../pages/admin/DataConnections.vue'], resolve),
        meta: {
            layout: 'content'
        }
    },
    {
        name: 'admin-data-tables',
        path: '/admin-data-tables',
        component: (resolve) =>
            require(['../pages/admin/DataTables.vue'], resolve),
        meta: {
            layout: 'content'
        }
    },
    {
        name: 'admin-file-manager',
        path: '/admin-file-manager',
        component: (resolve) =>
            require(['../pages/admin/FileManager.vue'], resolve),
        meta: {
            layout: 'content'
        }
    },
    {
        name: 'admin-settings-app',
        path: '/admin-settings-app',
        component: (resolve) =>
            require(['../pages/admin/SettingsApp.vue'], resolve),
        meta: {
            layout: 'content'
        }
    },
    {
        name: 'admin-pages',
        path: '/admin-pages',
        component: (resolve) =>
            require(['../pages/admin/Pages.vue'], resolve),
        meta: {
            layout: 'content'
        }
    },
    {
        name: 'admin-pages_item',
        path: '/admin-pages/:id',
        component: (resolve) =>
            require(['../pages/admin/PageDesigner.vue'], resolve),
        meta: {
            layout: 'content'
        }
    },
    {
        name: 'admin-users',
        path: '/admin-users',
        component: (resolve) =>
            require(['../pages/admin/Users.vue'], resolve),
        meta: {
            layout: 'content'
        }
    },
    {
        name: 'admin-roles',
        path: '/admin-roles',
        component: (resolve) =>
            require(['../pages/admin/Roles.vue'], resolve),
        meta: {
            layout: 'content'
        }
    },
    {
        name: 'admin-rolemembers',
        path: '/admin-rolemembers/:id',
        component: (resolve) =>
            require(['../pages/admin/RoleMembers.vue'], resolve),
        meta: {
            layout: 'content'
        }
    },
    {
        name: 'admin-mainmenus',
        path: '/admin-mainmenus',
        component: (resolve) =>
            require(['../pages/admin/MainMenus.vue'], resolve),
        meta: {
            layout: 'content'
        }
    },
    {
        name: 'admin-sidemenus',
        path: '/admin-sidemenus',
        component: (resolve) =>
            require(['../pages/admin/SideMenus.vue'], resolve),
        meta: {
            layout: 'content'
        }
    },
    {
        name: 'admin-permissions',
        path: '/admin-permissions',
        component: (resolve) =>
            require(['../pages/admin/Permissions.vue'], resolve),
        meta: {
            layout: 'content'
        }
    },
    {
        name: 'admin-tools',
        path: '/admin-tools',
        component: (resolve) =>
            require(['../pages/admin/Tools.vue'], resolve),
        meta: {
            layout: 'content'
        }
    },
]

export const devMenus = [
    {
        title: 'Data',
        icon: 'mdi-database-outline',
        type: 'group',
        children: [
            { title: 'Data Connections', type: 'route', url: '/admin-data-connections' },
            { title: 'Data Tables', type: 'route', url: '/admin-data-tables' },
            { title: 'Files', type: 'route', url: '/admin-file-manager' }
        ]
    },
    {
        title: 'UI',
        icon: 'mdi-monitor-screenshot',
        type: 'group',
        children: [
            { title: 'Application', type: 'route', url: '/admin-settings-app' },
            { title: 'Pages', type: 'route', url: '/admin-pages' },
            { title: 'Main Menus', type: 'route', url: '/admin-mainmenus' },
            { title: 'Side Menus', type: 'route', url: '/admin-sidemenus' },
        ]
    },
    {
        title: 'System',
        icon: 'mdi-cogs',
        type: 'group',
        children: [
            { title: 'Users', type: 'route', url: '/admin-users' },
            { title: 'Roles', type: 'route', url: '/admin-roles' },
            { title: 'Permissions', type: 'route', url: '/admin-permissions' },
            { title: 'Tools', type: 'route', url: '/admin-tools' },
        ]
    }
]